import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Image from 'next/image';
import { useState } from 'react';
import { colors } from '@/constants/colors';
import icToggleArrowUp from '@/public/images/ic-toggle-arrow-up.svg';

type Props = {
  title: React.ReactNode,
  item: React.ReactNode,
  overridePanelCss?: SerializedStyles,
};

const Collapse = ({ title, item, overridePanelCss = defaultPanelCss }: Props) => {
  const [isOpen, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Container isOpen={isOpen}>
      <Panel onClick={handleToggle} css={overridePanelCss}>
        {title}
        <ImageWrapper isOpen={isOpen}>
          <Image
            src={icToggleArrowUp}
            alt="토글 화살표"
            width={28}
          />
        </ImageWrapper>
      </Panel>

      <Expandable aria-expanded={isOpen}>
        <Content>
          {item}
        </Content>
      </Expandable>
    </Container>

  );
};

export default Collapse;

const Container = styled.div<{ isOpen: boolean }>`
${({ isOpen }) => isOpen &&
css`
  border-bottom: 1px solid ${colors.uiBorder}; 
`}
`;

const defaultPanelCss = css`
padding: 8px 8px 24px 16px;
`;

const Panel = styled.div`
display: flex;
align-items: center;
align-self: stretch;
justify-content: space-between;
border-bottom: 1px solid ${colors.uiBorder};
cursor: pointer;
`;

const ImageWrapper = styled.div<{ isOpen: boolean }>`
  transform: ${({ isOpen }) => isOpen ? 'rotate(0)' : 'rotate(180deg)'};
  transition: transform 0.2s ease-out;

  > img {
    display: block;
  }
`;

const Expandable = styled.div`
display: grid;
grid-template-rows: 0fr;
transition: grid-template-rows 0.3s ease-out;

&[aria-expanded='true'] {
  grid-template-rows: 1fr;
}
`;

const Content = styled.div`
overflow: hidden;
`;
